import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";



export const keys = {
    all: ["groups"],

    properties: (groupID: number
    ) => [
        ...keys.all,
        "properties", {
            groupID            
            }
    ],
    group: (customerID: number,
        groupID: number
        ) => [
            ...keys.all,
            "group", {
                customerID,
                groupID            
                }
        ],
    siblings: (customerID: number,
        groupID: number
        ) => [
            ...keys.all,
            "siblings", {
                groupID            
            }
        ],
    contents: (groupID: number
        ) => [
            ...keys.all,
            "contents", {
                groupID            
            }
        ],
    manualEntry: (groupID: number
            ) => [
                ...keys.all,
                "manualEntry", {
                    groupID            
                }
            ],
    systemBalance: (groupID: number
        ) => [
            ...keys.all,
            "systemBalance", {
                groupID            
            }
        ],

    membership: (groupID: number,
        objectID: number,
        objectType: eLynxObjectTypeEnum
        ) => [
            ...keys.all,
            "membership", {
                groupID,
                objectID,
                objectType            
            }
        ],
    
    dynamicCriteria: (groupID: number
        ) => [
            ...keys.all,
            "dynamicCriteria", {
                groupID            
            }
        ],
    tats: (groupID: number
        ) => [
            ...keys.all,
            "tats", {
                groupID            
            }
        ],
    tatsInUse: (groupID: number
        ) => [
            ...keys.all,
            "tatsInUse", {
                groupID            
            }
        ],
    tankBatteries: (groupID: number
        ) => [
            ...keys.all,
            "tankBatteries", {
                groupID            
            }
        ]        
};